<template><svg viewBox="0 0 27 24" version="1.1"
xmlns="http://www.w3.org/2000/svg" :width="width"
:height="height"><title>{{title}}</title><g :fill="fill"><g id="Page-1"
stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Group"
transform="translate(10 6)" stroke-linecap="round" stroke-linejoin="round"
stroke-width="2" :stroke="fill"><path id="Line" d="M0 3.5h16L11.5 0"/><path
id="Line" transform="matrix(1 0 0 -1 0 10.5)" d="M0 7h16l-4.5-3.5"/></g><g
id="login-2" fill-rule="nonzero" :fill="fill"><path d="M15.875
0H1.4C.64.13.094.803.125 1.573v17.475a1.74 1.74 0 0 0 1.1 1.625l8 3.2a1.75
1.75 0 0 0 2.4-1.625v-17a1.744 1.744 0 0 0-1.1-1.625L7.664 2.482A.25.25 0 0 1
7.757 2h7.868a.25.25 0 0 1 .25.25v16.475a.25.25 0 0 1-.25.25h-1.75a1 1 0 0 0 0
2h2a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" id="Path"/></g></g></g></svg></template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: '100%',
    },
    height: {
      type: [Number, String],
      default: '100%',
    },
    title: {
      type: String,
      default: 'logout',
    },
    fill: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>
